import { useEffect } from 'react';

export interface PageMetaProps {
  /** Already localized and already interpolated. This component never calls `t`. */
  title: string;
}

/**
 * Sets the document title for the current screen. Renders nothing.
 *
 * `document.title` is assigned directly rather than rendered as a `<title>` element. React 19 does
 * hoist a rendered `<title>` into `<head>`, but it *prepends* it and leaves the one from
 * `index.html` in place — so the correct title is only observed because `document.title` reads the
 * first element, an ordering React does not document. Assigning wins on determinism: one title
 * element, one owner, and a mis-set title on a payment page is a trust problem.
 *
 * `theme-color` and the favicon are deliberately not handled here. They are branding-driven document
 * singletons and live in `applyBranding` (ADR-030), because React *appends* `<meta>` and browsers
 * honour the first `theme-color` — a rendered one would be silently ignored.
 */
export function PageMeta({ title }: PageMetaProps) {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return null;
}
